// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { customerSchema } from '@/customer/api/types';
import { paymentTermSchema } from '@/payment-term/api/types';
import { dateSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

// Text fields on the form are stored as plain strings (empty string for
// "blank"). The submit handler normalizes "" to null for nullable fields
// before building the API payload. Dates are stored as DateTime values.
// Payment term is stored as the full PaymentTerm object (or null) so the
// autocomplete can show the label; the submit handler projects it down
// to the label string that the backend persists. Customer is stored as
// the full Customer object so auto-fill can access billing fields; the
// submit handler projects it down to just the key string.
export const invoiceEditFormSchema = z.object({
  invoiceNumber: z.string().min(1, 'Invoice number is required'),
  customer: customerSchema.nullable(),
  invoiceDate: dateSchema,
  dueDate: dateSchema.nullable(),
  paymentTerm: paymentTermSchema.nullable(),
  billFromName: z.string().min(1, 'Bill from name is required'),
  billFromAddress: z.string(),
  billToCompanyName: z.string(),
  billingContactName: z.string(),
  billToAddress: z.string(),
  billToPhone: z.string(),
  billToEmail: z.string(),
  purchaseOrderNumber: z.string(),
});

export type InvoiceEditFormData = z.infer<typeof invoiceEditFormSchema>;
